import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductPageBody } from "../productModulesBody";

/**
 * tempurpedic ProductLinePage ``modules`` body assembly (#33589).
 *
 * The legacy ``product_line_page.html`` rendered the body via the whole-field
 * ``{% include_block self.modules %}`` (Wagtail ``StreamBlock.render_basic``),
 * which wraps every top-level block in ``<div class="w-block-{type}
 * block-{type}">`` -- the validated Phase-2 whole-field convention. This
 * consolidates into a single ``include_react`` root with ``wrapBlocks`` set so
 * the shared assembly reproduces that per-block wrapper. The hero chrome above
 * it stays in the page template.
 *
 * ``ProductLinePage.configurator_based_modules`` is OUT of scope (served through
 * the configurator segment serializer, never template-rendered), so this
 * assembly only covers ``modules``; the PLP has no alt-design body filter
 * (``useDefaultDesign`` unset -> render every top-level block).
 */
type IProps = Immutable<
    Pick<
        templates.ProductLinePageTemplate,
        | "page"
        | "hardcoded_ssr"
        | "hotspot_ssr"
        | "breadcrumbs_ssr"
        | "customer_service_ssr"
        | "shop_compare_ssr"
        | "tab_feature_attribute_ssr"
        | "reviews_ssr"
        | "reviews"
        | "page_num_reviews"
        | "change_variant_ssr"
        | "change_root_ssr"
        | "root_conditional_ssr"
        | "variant_conditional_ssr"
        | "tab_cards_initial_root_product_id"
    >
>;

export const ProductLinePageBody = (
    props: IProps,
): React.JSX.Element | null => {
    // ``modules`` is nullable (``null=True, blank=True``); render nothing when
    // null/empty.
    if (!props.page.modules) {
        return null;
    }
    return (
        <ProductPageBody
            value={props.page.modules.value}
            wrapBlocks={true}
            hardcoded_ssr={props.hardcoded_ssr}
            hotspot_ssr={props.hotspot_ssr}
            breadcrumbs_ssr={props.breadcrumbs_ssr}
            customer_service_ssr={props.customer_service_ssr}
            shop_compare_ssr={props.shop_compare_ssr}
            tab_feature_attribute_ssr={props.tab_feature_attribute_ssr}
            reviews_ssr={props.reviews_ssr}
            reviews={props.reviews}
            pageNumReviews={props.page_num_reviews}
            changeVariantSSR={props.change_variant_ssr}
            changeRootSSR={props.change_root_ssr}
            rootConditionalSSR={props.root_conditional_ssr}
            variantConditionalSSR={props.variant_conditional_ssr}
            tabCardsInitialRootProductID={
                props.tab_cards_initial_root_product_id
            }
        />
    );
};
